import React, { useState } from "react";
import { db } from "../lib/firebase";
import { collection, writeBatch, doc, serverTimestamp } from "firebase/firestore";

const AdminBulkUpload = () => {
    const [previewData, setPreviewData] = useState([]);
    const [uploading, setUploading] = useState(false);
    const [progress, setProgress] = useState("");
    const [error, setError] = useState("");

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (event) => {
                try {
                    const data = JSON.parse(event.target.result);
                    if (Array.isArray(data)) {
                        setPreviewData(data);
                        setError("");
                    } else {
                        setError("JSON formatı hatalı: Bir dizi (array) olmalı.");
                    }
                } catch (err) {
                    setError("Dosya okunamadı veya geçerli bir JSON değil.");
                }
            };
            reader.readAsText(file);
        }
    };

    const handleBulkUpload = async () => {
        if (!previewData.length) return;
        setUploading(true);
        setProgress("Başlatılıyor...");

        const batchSize = 450;
        const total = previewData.length;
        let loadedCount = 0;

        // Chunk array
        const chunks = [];
        for (let i = 0; i < total; i += batchSize) {
            chunks.push(previewData.slice(i, i + batchSize));
        }

        try {
            for (const chunk of chunks) {
                const batch = writeBatch(db);

                chunk.forEach((item) => {
                    const newDocRef = doc(collection(db, "products"));
                    const productData = {
                        title: item.title || item.name || "İsimsiz Ürün",
                        price: typeof item.price === 'string' ? parseFloat(item.price) : Number(item.price),
                        category: item.category || "Genel",
                        brand: item.brand || "",
                        description: item.description || "",
                        imageUrl: item.imageUrl || "",
                        stock: item.stock ? Number(item.stock) : 0,
                        isActive: item.isActive !== undefined ? item.isActive : true,
                        createdAt: serverTimestamp(),
                        updatedAt: serverTimestamp()
                    };

                    // Remove undefined fields
                    Object.keys(productData).forEach(key => productData[key] === undefined && delete productData[key]);

                    batch.set(newDocRef, productData);
                });

                await batch.commit();
                loadedCount += chunk.length;
                setProgress(`Yüklendi: ${loadedCount} / ${total}`);
            }

            alert(`Tamamlandı! Toplam ${loadedCount} ürün başarıyla yüklendi.`);
            setPreviewData([]);
            setProgress("");
        } catch (err) {
            console.error("Yükleme hatası:", err);
            setError("Yükleme sırasında bir hata oluştu: " + err.message);
        } finally {
            setUploading(false);
        }
    };

    return (
        <div className="p-10 max-w-4xl mx-auto bg-white rounded-xl shadow">
            <h2 className="text-2xl font-bold mb-6 text-[#064e3b]">Toplu Ürün Yükleme</h2>

            <div className="mb-8 p-6 bg-gray-50 rounded-xl border border-dashed border-gray-300">
                <label className="block mb-2 font-bold text-gray-700">JSON Dosyası Seç</label>
                <input
                    type="file"
                    accept=".json"
                    onChange={handleFileChange}
                    className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-[#d97706] file:text-white hover:file:bg-[#b45309]"
                />
                {error && <p className="mt-2 text-red-600 font-medium">{error}</p>}
            </div>

            {previewData.length > 0 && (
                <div className="mb-8">
                    <div className="flex justify-between items-center mb-4">
                        <h3 className="text-lg font-bold text-gray-800">Önizleme ({previewData.length} Ürün)</h3>
                        <button
                            onClick={handleBulkUpload}
                            disabled={uploading}
                            className={`px-6 py-2 rounded-lg font-bold text-white transition-all ${uploading ? "bg-gray-400 cursor-not-allowed" : "bg-[#d97706] hover:bg-[#b45309]"
                                }`}
                        >
                            {uploading ? "Yükleniyor..." : "Firestore'a Yükle"}
                        </button>
                    </div>

                    {progress && (
                        <div className="mb-4 p-3 bg-blue-50 text-blue-700 rounded-lg font-medium border border-blue-200">
                            {progress}
                        </div>
                    )}

                    <div className="overflow-x-auto border rounded-lg max-h-[400px]">
                        <table className="w-full text-left text-sm">
                            <thead className="bg-[#064e3b] text-white sticky top-0">
                                <tr>
                                    <th className="p-3">Title / Name</th>
                                    <th className="p-3">Price</th>
                                    <th className="p-3">Category</th>
                                    <th className="p-3">Brand</th>
                                    <th className="p-3">Stock</th>
                                </tr>
                            </thead>
                            <tbody>
                                {previewData.slice(0, 50).map((item, idx) => (
                                    <tr key={idx} className="border-b hover:bg-gray-50">
                                        <td className="p-3 font-medium text-gray-900">{item.title || item.name}</td>
                                        <td className="p-3">{item.price}</td>
                                        <td className="p-3">{item.category}</td>
                                        <td className="p-3">{item.brand}</td>
                                        <td className="p-3">{item.stock}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        {previewData.length > 50 && (
                            <div className="p-3 text-center text-gray-500 text-xs bg-gray-50 border-t">
                                ... ve {previewData.length - 50} ürün daha
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default AdminBulkUpload;
